import {
  createCountPipeline,
  createFilteringStage,
  createPagingStages,
  createSortStage,
  CustomPipelineFactory,
} from '@/providers/dataProvider';
import { createDefaultTherapistsFilter } from '../therapists/therapistMatchers';
import { aggregate } from '@/providers/backendClient';

export const therapistPatientsCustomFetcher: CustomPipelineFactory =
  async ({ sort, filter: filterValues, page, perPage }) => {
    const combinedFilter =
      await createDefaultTherapistsFilter(filterValues);

    const match = createFilteringStage(combinedFilter);

    const sortStage = createSortStage(sort);

    const pagingPipeline = createPagingStages(page, perPage);

    const resultsPipeline = [
      match,
      sortStage,
      ...pagingPipeline,
      ...transformationPipeline,
    ];

    const countPipeline = createCountPipeline([match]);

    const pipelines = {
      results: resultsPipeline,
      total: countPipeline,
    };

    const { results, total: [{ count = 0 } = {}] = [] } =
      await aggregate('therapistPatients', pipelines);

    return { results, total: count };
  };

export const transformationPipeline = [
  {
    $addFields: {
      patientFirstName: {
        $binarySize: '$patientFirstName',
      },
      patientLastInitial: {
        $binarySize: '$patientLastInitial',
      },
    },
  },
  {
    $project: {
      patientPublicKey: 0,
      therapistEmail: 0,
      therapistFirstName: 0,
      therapistLastName: 0,
      therapistPhoneNumber: 0,
      therapistPublicKey: 0,
      therapistTitle: 0,
    },
  },
  {
    $lookup: {
      from: 'therapists',
      localField: 'therapistId',
      foreignField: '_id',
      as: 'therapist',
    },
  },
  {
    $unwind: {
      path: '$therapist',
      preserveNullAndEmptyArrays: false,
    },
  },
  {
    $addFields: {
      therapistEmail: '$therapist.email',
      therapistTitle: '$therapist.title',
      therapistFirstName: '$therapist.firstName',
      therapistLastName: '$therapist.lastName',
      therapist: null,
    },
  },
  {
    $project: {
      therapist: 0,
    },
  },
];
